const ScreenRecRight = () => {
  return (
    <div className="flex flex-col items-start justify-between h-full w-[80%] mx-auto pb-10">
      <div className="flex flex-col">
        <h1 className="heading1 mb-10">
          Mandatory Screen Recording Instructions for Candidates
        </h1>
        <ul className="flex flex-col gap-4 text-[#444] listDisc text-base list-outside list-disc">
          <li>
            Press <strong>"Start Recording"</strong> button on left and give
            permission to share screen.
          </li>
          <li>
            Please select your <strong>Entire screen</strong> while sharing
            screen.
          </li>
          <li>Don’t edit or modify the screen recording in any way.</li>
          <li>
            Don’t pause or stop the recording at any time during the test.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ScreenRecRight;
